module.exports = __webpack_public_path__ + "img/2020-2_188cc701d.png";